import { Button, useTheme } from '@material-ui/core';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import clsx from 'clsx';

import { backgrounds } from '@vyce/core/src/theme/styles';
import { buttonTypes, ButtonProps } from '../types';
import { useStyles } from '../styles';

export const PaginationButton = ({ type, disabled, setPage, width, extraSmallMobile }: ButtonProps) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <Button
      size="small"
      disabled={disabled}
      onClick={() => setPage()}
      className={clsx({ [classes.buttonWrapper]: extraSmallMobile })}
      style={{
        height: 32,
        width,
        color: disabled ? theme.palette.divider : theme.palette.primary.main,
        borderRadius: '16px',
        backgroundColor: theme.palette.type === 'dark' ? backgrounds.darkModePaper : backgrounds.paper,
      }}
      startIcon={type === buttonTypes.PREVIOUS && <FaChevronLeft size="12px" />}
      endIcon={type === buttonTypes.NEXT && <FaChevronRight size="12px" />}
      variant="outlined"
    >
      {extraSmallMobile ? '' : type}
    </Button>
  );
};
